import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';


import {LogoutService} from './logout.service';


@Component({
    selector: 'logout',
    template: require('./logout.component.html'),
    providers: [LogoutService]
})
export class SuperUserLogoutComponent implements OnInit {
    router: Router;

    constructor(private _logoutService: LogoutService, _parentRouter: Router) {
        this.router = _parentRouter;
    }

    ngOnInit() {
        if(this._logoutService.logout()) {
            this.router.navigate(['/main', 'dashboard']);
        };
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/logout/logout.component.ts
 **/